<template>
  <div class="cdetyzhttj">
    <sub-title text="优质相关话题推荐" />
    <div class="yzhttjlist">
      <div class="yzhttjitem flex_start" v-for="item in 4" :key="item">
        <div class="xiaoicon">
          <img src="../../../assets/zx_consult/yzxghticon.png" alt="" />
        </div>
        <div class="htxqtxt">
          <div class="htbtbq flex_start">
            <div class="name">
              {{
                `异地协议离婚怎么办` | toEllipsisFilter(20)
              }}
            </div>
            <div class="labe">离婚</div>
            <div class="labe">16:16:18</div>
            <div class="labe flex_start">
              <img src="../../../assets/base/kan.png" /> 13456 浏览
            </div>
          </div>
          <div class="htjd">
            {{
              `话题解答：关于异地离婚的问题，如果是协议离婚可以直接去颁发结婚证的民政局办理手续也可以去双
            方任意一方户籍所在地民政局办理。` | toEllipsisFilter(80)
            }}
          </div>
          <div class="gengduo">更多></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.cdetyzhttj {
  width: 100%;
  padding: 30px 25px 0;
  .yzhttjlist {
    .yzhttjitem {
      align-items: flex-start;
      padding: 35px 10px 26px;
      position: relative;
      border-bottom: 1px solid #ccc;
      .xiaoicon {
        margin-right: 10px;
        width: 24px;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .htxqtxt {
        position: relative;
        .htbtbq {
          .name {
            font-size: 20px;
            color: #333333;
            margin-right: 30px;
          }
          .labe {
            font-size: 14px;
            color: #cccccc;
            margin-right: 20px;
            img {
              margin-right: 5px;
              width: 14px;
              height: 10px;
            }
          }
        }
        .htjd {
          margin-top: 15px;
          font-size: 16px;
          color: #999999;
          line-height: 24px;
        }
        .gengduo {
          position: absolute;
          bottom: 0;
          right: 0;
          cursor: pointer;
          font-size: 14px;
          color: #0465ea;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>